import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbAlertModule } from "@ng-bootstrap/ng-bootstrap";

import { UiModule } from "../../shared/ui/ui.module";
import { AuthRoutingModule } from "./auth-routing";

import { LoginComponent } from "./login/login.component";
import { SignupComponent } from "./signup/signup.component";
import { PasswordresetComponent } from "./passwordreset/passwordreset.component";
import { TranslateModule } from "@ngx-translate/core";
import { WorkspaceComponent } from "./workspace/workspace.component";
import { ChartsModule } from "ng2-charts";
import { LoginMobileComponent } from "./login-mobile/login-mobile.component";
import { WorkspaceMobileComponent } from "./workspace-mobile/workspace-mobile.component";
import { LoginAcccountComponent } from "./login-acccount/login-acccount.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { FormPageComponent } from "./form-page/form-page.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MAT_SELECT_CONFIG, MatSelectModule } from "@angular/material/select";
import { MatExpansionModule } from "@angular/material/expansion";
import {
  NgbNavModule,
  NgbDropdownModule,
  NgbTooltipModule,
  NgbPaginationModule,
  NgbDatepickerModule,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [
    LoginComponent,
    SignupComponent,
    PasswordresetComponent,
    WorkspaceComponent,
    LoginMobileComponent,
    WorkspaceMobileComponent,
    LoginAcccountComponent,
    LandingPageComponent,
    FormPageComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbAlertModule,
    UiModule,
    AuthRoutingModule,
    TranslateModule,
    FormsModule,
    ChartsModule,
    NgSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatExpansionModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPaginationModule,
    NgbDatepickerModule,
    NgSelectModule,
  ],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: "customClass" },
    },
  ],
})
export class AuthModule {}
